export { SimpleEventMobileSponsors } from './SimpleEventMobileSponsors';
